import request from '@/utils/request'

//轮播图
export function bannerList() {
  return request({
    url: `/banner/list`,
    method: 'post',
  })
}
//查询所有菜单
export function menuAll() {
  return request({
    url: `/menu/listAll`,
    method: 'get',
  })
}
//查询一级菜单/二级菜单
export function menu(parentId) {
  return request({
    url: `menu/list?parentId=${parentId}`,
    method: 'get',
  })
}
//富文本
export function singleinfo(id) {
  return request({
    url: `singleInfo/${id}`,
    method: 'get',
  })
}
//列表不分页
export function contentList(menuId) {
  return request({
    url: `content/list?menuId=${menuId}`,
    method: 'get',
  })
}
//列表分页
export function contentPage(pageNum, pageSize, menuId, search, contentSort,type,img,contentType) {
  if (!type) {
    type = ''
  }
  if (!search) {
    search = ''
  }
  if (!contentSort) {
    contentSort = ''
  }
  if (!img) {
    img = 0
  }
  
  if (!contentType) {
    contentType = ''
  }
  return request({
    url: `content/page?pageNum=${pageNum}&pageSize=${pageSize}&menuId=${menuId}&search=${search}&contentSort=${contentSort}&type=${type}&img=${img}&contentType=${contentType}`,
    method: 'get',
  })
}
//翻页
export function flipping(menuId,id){
  return request({
    url: `content/detailed/page?menuId=${menuId}&id=${id}`,
    method: 'get',
  })
}

//查询业务领域列表
export function businessList() {
  return request({
    url: `business/list`,
    method: 'get',
  })
}
//业务领域详情
export function businessDetail(id) {
  return request({
    url: `business/${id}`,
    method: 'get',
  })
}

//业务领域-模块一列表
export function businessOneList(pageNum,pageSize,id) {
  return request({
    url: `business/one/type/list/?pageNum=${pageNum}&pageSize=${pageSize}&businessId=${id}&contentSort=1`,
    method: 'get',
  })
}

//业务领域-模块一详情
export function businessOne(id) {
  return request({
    url: `business/one/list/?typeName=${id}`,
    method: 'get',
  })
}

//业务领域-模块二
export function businessTwo(id) {
  return request({
    url: `business/two/list/?businessId=${id}`,
    method: 'get',
  })
}

//业务领域-模块三
export function businessThree(id) {
  return request({
    url: `business/three/list/?businessId=${id}`,
    method: 'get',
  })
}
//联系我们
export function contactUs() {
  return request({
    url: `unit/up/list`,
    method: 'get',
  })
}

//友情链接
export function unitList() {
  return request({
    url: `unit/list`,
    method: 'get',
  })
}

//下属企业列表
export function unitBelowList() {
  return request({
    url: `unit/unit/below/list`,
    method: 'get',
  })
}
//业主反馈列表分页
export function ownerFeedbackPage(pageNum, pageSize) {
  return request({
    url: `ownerFeedback/page?pageNum=${pageNum}&pageSize=${pageSize}`,
    method: 'get',
  })
}
//业主反馈详情
export function ownerFeedbackInfo(id){
  return request({
    url: `ownerFeedback/info/${id}`,
    method: 'get',
  })
}
//业主反馈上一篇/下一篇
export function ownerFeedbackNavigation(id) {
  return request({
    url: `ownerFeedback/navigation/${id}`,
    method: 'get',
  })
}
//重点项目获取分类列表
export function keyProjectCategory() {
  return request({
    url: `keyProjectCategory/list`,
    method: 'get',
  })
}
//重点项目按分类ID分页获取项目列表
export function keyProjectListByCategoryId(pageNum, pageSize, categoryId) {
  return request({
    method: 'get',
    url: `keyProject/listByCategoryId?pageNum=${pageNum}&pageSize=${pageSize}&categoryId=${categoryId}`,
  })
}
//重点项目项目详情
export function keyProjectInfo(id){
  return request({
    url: `keyProject/info/${id}`,
    method: 'get',
  })
}
//重点项目上一篇/下一篇（同分类）
export function keyProjectNavigation(id) {
  return request({
    url: `keyProject/navigation/${id}`,
    method: 'get',
  })
}
//人才招聘分页查询招聘信息列表
export function jobPostingList(pageNum, pageSize) {
  return request({
    url: `jobPosting/list?pageNum=${pageNum}&pageSize=${pageSize}`,
    method: 'get',
  })
}
//人才招聘获取招聘信息详情
export function jobPostingInfo(id){
  return request({
    url: `jobPosting/${id}`,
    method: 'get',
  })
}
//公司业绩获取栏目列表
export function performanceCategory() {
  return request({
    url: `performanceCategory/list`,
    method: 'get',
  })
}
//公司业绩获取栏目列表按栏目ID分页获取项目列表
export function performanceProjectListByCategoryId(pageNum, pageSize, categoryId) {
  return request({
    method: 'get',
    url: `performanceProject/listByCategoryId?pageNum=${pageNum}&pageSize=${pageSize}&categoryId=${categoryId}`,
  })
}
//公司业绩项目详情
export function performanceProjectInfo(id){
  return request({
    url: `performanceProject/info/${id}`,
    method: 'get',
  })
}
//公司业绩获取项目导航
export function performanceProjectNavigation(id){
  return request({
    url: `performanceProject/navigation/${id}`,
    method: 'get',
  })
}
//获取海报列表
export function posterList() {
  return request({
    url: `poster/list`,
    method: 'get',
  })
}


// WEBPACK FOOTER //
// ./src/api/api.js